import { isRecord } from "./trafficAssignmentsData";
import type { RuleRecord } from "./ruleBlocksData";
import type { FormFieldAction } from "src/view/formFieldActions";

export const ASSIGNMENT_TARGET_ACTION = "select-assignment-target";

/** Add the target picker action; keep server fields, thresholds and layout intact. */
export const prepareAssignmentForm = (source: RuleRecord, label: (key: string) => string): RuleRecord => {
	const form = structuredClone(source);
	const targetField = isRecord(form.$__target_id) ? form.$__target_id : {};
	const targetAction: FormFieldAction = {
		id: ASSIGNMENT_TARGET_ACTION, label: label("chooseList"), text: "…", popup: true,
		linked: "target_type", linked_value: ["client", "merchant"],
	};
	form.$__target_id = { ...targetField, actions: [...(Array.isArray(targetField.actions) ? targetField.actions : []), targetAction] };
	return form;
};

/** The client is already chosen: keep the server form and thresholds, but fill and hide its target fields. */
export const prepareClientAssignmentForm = (source: RuleRecord, clientId: number): RuleRecord => {
	const form = structuredClone(source);
	form.target_type = "client";
	form.target_id = clientId;
	for (const field of ["target_type", "target_id"]) {
		const meta = form[`$__${field}`];
		form[`$__${field}`] = { ...(isRecord(meta) ? meta : {}), hidden: true };
	}
	return form;
};
